<template>
  <div>
    <div id="refreshButtonWrapper">
      <v-btn style="width: 150px" class="mr-2" color="#dfe4ee" @click="getData()" :loading="refreshing">
        <v-icon class="mr-2" color="#8e9298">mdi-refresh</v-icon>
        <span color="#8e9298">{{ $t("refresh") }}</span>
      </v-btn>
    </div>
    <v-data-table :headers="headers" :items="list" :items-per-page="pageOptions.itemsPerPage" disable-sort class="tbl-list" :footer-props="footerProps" :no-results-text="$t('no_result_found')" :no-data-text="$t('no_data_found')" :options.sync="pageOptions" :server-items-length="totalItems" @update:page="onPageChanged" @update:items-per-page="onItemsPerPageChanged">
      <template v-slot:header>
        <tr>
          <td></td>
          <td v-if="showSelect"></td>
          <td>
            <v-text-field v-model="searchTckn" :label="$t('tckn')" class="mx-4" @keyup="inputKeyUp" :maxlength="11"></v-text-field>
          </td>
          <td>
            <v-autocomplete v-model="leadIds" :items="leadPartyNameDTOList" clearable multiple item-text="fullName" item-value="id" :label="$t('fullName')" class="mx-4" @change="onLeadPartyFilterChanged" :search-input.sync="leadPartySearch" :no-data-text="$t('no_data_found')"></v-autocomplete>
          </td>
          <td>
            <v-select class="mx-4" v-model="selectedProcessDefinitionCode" :items="processDefinitionCodeList" :label="$t('processDefinition')" @change="inputKeyUp" :no-data-text="$t('no_data_found')"></v-select>
          </td>
          <td colspan="3"></td>
          <td>
            <v-select class="mx-4" v-model="searchUnitCode" :items="unitCodeItems" :disabled="searchUnitCodeDisabled" :label="$t('consultantUnit')" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
          <td>
            <v-select v-model="searchAssignedName" :items="consultantItems" :label="$t('investmentConsultant')" class="mx-4" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
          <td colspan="1"></td>
          <td>
            <v-select class="mx-4" v-model="applicationName" :items="applicationNameItems" :disabled="applicationNameDisabled" :label="$t('applicationInformation')" @change="inputKeyUp" :no-data-text="$t('no_data_found')" clearable></v-select>
          </td>
        </tr>
      </template>
      <template #item="{ item }">
        <tr :key="'rd_' + item.leadParty.id" :class="'row-data' + ' ' + 'row_' + item.leadParty.id" @mouseenter="
            onMouseEnterRow($el.querySelectorAll('.row_' + item.leadParty.id))
          " @mouseleave="
            onMouseLeaveRow($el.querySelectorAll('.row_' + item.leadParty.id))
          ">
          <td v-if="showSelect">
            <v-checkbox v-model="item.checked" @change="onCheckboxChanged"></v-checkbox>
          </td>
          <td>
            <v-btn icon @click="
                onClickCustomerCard(
                  item.leadParty.id,
                  item.leadParty.tckn,
                  item.processId,
                  item.note
                )
              ">
              <v-icon :color="
                  item.leadParty.riskGroupDTO &&
                  item.leadParty.riskGroupDTO.colorCode
                    ? item.leadParty.riskGroupDTO.colorCode
                    : 'blue darken-2'
                " size="32">mdi-account-search</v-icon>
            </v-btn>
          </td>
          <td>{{ item.leadParty.tckn }}</td>
          <td>{{ item.leadParty.fullName }}</td>
          <td>
            <template v-if="
                item.processDefinition.code === 'SELF_ONBOARDING_PROCESS' ||
                  item.processDefinition.code === 'LEAD_APPROVAL_PROCESS'
              ">
              <v-icon color="#8e9298">{{ item.processDefinition.code === "SELF_ONBOARDING_PROCESS" ? "mdi-account-cash" : "mdi-file-document-edit" }}
              </v-icon>
            </template>
            <template v-else>
              <template v-if="item.processDefinition.code === 'NFC_AND_VIDEO_PROCESS'">
                <v-icon color="#8e9298">mdi-cellphone-nfc</v-icon>
                <v-icon color="#8e9298">mdi-webcam</v-icon>
              </template>
              <template v-if="item.processDefinition.code === 'VIDEO_CALL_PROCESS_V2'">
                <v-icon color="#8e9298">mdi-webcam</v-icon>
              </template>
            </template>
          </td>
          <td>{{ formatDate(item.startTime) }}</td>
          <td>{{ item.resourceDescription }}</td>
          <td>
            {{ item.businessProcessStatus.value }}
          </td>
          <td>{{ getAssigneeUser(item.assigneeId).unitType }}</td>
          <td>{{ getAssigneeUser(item.assigneeId).fullName }}</td>
          <td>{{ $t(item.leadParty.channel) }}</td>
          <td>{{ item.processDefinition.onboardingProcessApplication.description }}</td>
          <td>{{ $t(item.leadParty.meetingChoice) }}</td>
          <td>
            {{ formatAppointmentDateTimeField(item.leadParty.appointmentDTO) }}
          </td>
        </tr>

        <tr :key="'ra_' + item.leadParty.id" :class="'row-actions' + ' ' + 'row_' + item.leadParty.id" @mouseenter="
            onMouseEnterRow($el.querySelectorAll('.row_' + item.leadParty.id))
          " @mouseleave="
            onMouseLeaveRow($el.querySelectorAll('.row_' + item.leadParty.id))
          " @click="setProcessId(item.processId)">
          <td :colspan="headers.length">
            <div class="adjust-right" v-if="item.showVideoStarted">
              <v-btn outlined class="action" @click="onClickRefreshRoom(item.processId)">
                {{ $t("refreshRoom") }}
              </v-btn>
            </div>

            <div class="adjust-right" v-if="item.showFinalApproval">
              <v-btn outlined class="action" @click="
                  onClickFinalApproval(
                    item.processId,
                    item.leadParty.tckn
                  )
                ">
                {{ $t("finalizeProcess") }}
              </v-btn>
            </div>

            <div class="adjust-right" v-if="item.showWaitingApproval">
              <v-btn outlined class="action" @click="
                  onClickWaitingApproval(
                    item.processId,
                    item.leadParty.tckn
                  )
                ">
                {{ $t("waitingApproval") }}
              </v-btn>
            </div>
            <div class="adjust-right" v-if="item.showWaitingToSendApproval">
              <v-btn outlined class="action" @click="
                  onClickWaitingToSendApproval(
                    item.processId,
                    item.leadParty.tckn
                  )
                ">
                {{ $t("waitingToSendApproval") }}
              </v-btn>
            </div>

            <div class="adjust-right" v-if="item.showWaitingToSendPreApprove"> 
              <v-btn outlined class="action" @click="
                  onClickWaitingToSendPreApprove(
                    item.processId,
                    item.leadParty.tckn,
                  )
                ">
                {{ $t("showWaitingToSendPreApprove")}}
              </v-btn>  
            </div>

            <div class="adjust-right" v-if="item.showVideoConference">
              <v-btn id="btn-join-video-call" class="action" color="primary" @click="
                  onClickJoinVideoCall(
                    item.leadParty.fullName,
                    item.leadParty.tckn,
                    item.leadParty.id,
                    item.processId,
                    item.leadParty.primaryContactType
                  )
                ">
                {{ $t("joinVideoConversation") }}
              </v-btn>
            </div>  
            <div class="adjust-right" v-if="item.showDropAssignee">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined @click="onClickDropAssignee(item.processId, item.leadParty.id)">
                    <v-icon>mdi-keyboard-return</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("dropAssignee") }}</span>
              </v-tooltip>
            </div>
            <div class="adjust-right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined @click="onClickAddNote(item.processId)">
                    <v-icon>mdi-message-plus-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("addNote") }}</span>
              </v-tooltip>
            </div>
            <div class="adjust-right" v-if="item.showSendLink">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined @click="onClickSendLink(item.processId, item.leadParty.id)">
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("sendLink") }}</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OngoingProcessListTable from "./mixin/OngoingProcessListTable";
import PartyProcessListTableCommon from "./mixin/PartyProcessListTableCommon";

export default {
  mixins: [OngoingProcessListTable, PartyProcessListTableCommon]
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;
$rowBackgroundColor: #dfe4ee;
$hoverColor: #eeeeee;

#refreshButtonWrapper {
  text-align: end;
  margin-bottom: 1%;
}
.tbl-list /deep/ {
  margin-top: 5%;

  tbody tr {
    background-color: $rowBackgroundColor;
    &:nth-child(4n + 3) {
      background-color: white;
    }
    &:nth-child(4n + 4) {
      background-color: white;
    }
    &.hovered {
      background-color: $hoverColor;
    }
    &.row-data {
      td {
        border-bottom: none !important;
      }
    }
    &.row-actions {
      .contact-management-column {
        text-align: start;
      }
      td {
        padding-top: 30px !important;
        padding-bottom: 10px !important;
      }
    }
  }
}
.action {
  width: 100%;
  border-color: $primaryColor;
  color: $primaryColor;
  font-weight: bold;
}
#btn-choose-process {
  color: $primaryColor;
}
#btn-join-video-call {
  color: white;
}
.v-btn {
  text-transform: none;
}
.adjust-right {
  float: right;
  margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/OngoingProcessListTable.vue